module.exports = __webpack_public_path__ + "static/media/legly_on_ipad.443f6111.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/legly_on_ipad.jpg
// module id = 274
// module chunks = 0